var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-chip',{attrs:{"color":_vm.statusItem.color,"text-color":"white"}},[(_vm.statusItem.icon)?_c('v-icon',{attrs:{"left":"left"}},[_vm._v(_vm._s(_vm.statusItem.icon))]):_vm._e(),_vm._v(_vm._s(_vm._f("uppercase")(_vm.statusItem.label)))],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ac24966e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ultra-fetal/reportStatus/index.vue
// module id = 1Jqu
// module chunks = 1